import { QuestionCircleOutlined } from '@ant-design/icons'
import { Tooltip } from 'antd'
import React from 'react'
import { ListaServicios } from './ListaServicios'

export const ServiciosAutorizados = () => {
  return (
    <div style={{padding: 10}}>
      <div className='titulo_lista'>
        Servicios Autorizados
        <Tooltip title="Puedes generar la OP de los siguientes servicios, recuerda agrupar por cliente, mes y si es local - carretero">
          <QuestionCircleOutlined
            style={{ color: 'orange', marginLeft: 5, fontSize: 18 }}
            className='eyeIcon' />
        </Tooltip>
      </div>
      <ListaServicios />
    </div>
  )
}
